const secondaryMenu = document.querySelectorAll('.secondary-menu')

document.addEventListener('turbo:load', () => {
  window.addEventListener('scroll', () => {
    const newTop = Math.max(70, 114 - window.scrollY)
    secondaryMenu.forEach( (secondaryMenu) => {
      secondaryMenu.style.top = `${newTop}px`
    })
  })
})